let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5coOi"), load("jdHbV"), load("3VLKz"), load("jwSno"), load("4XFRu"), load("4sZyu")]).then(() => parcelRequire('3iK0z'));